import useTranslation from 'next-translate/useTranslation';

import { Routes } from '~/domains/common/constants/routes';
import dt from '~/testing';

import { useContestContext } from '../../../context/ContestContext/ContestContext';
import { useIsContestMarketplaceEnabled } from '../../../hooks/useIsContestMarketplaceEnabled';

import { GamecenterNonScheduledNavListItem } from './GamecenterNonScheduledNavComponents';

function GamecenterMarketplaceNavItem({ contestId }: { contestId: string }) {
  const { t } = useTranslation('contest');
  const { contest } = useContestContext();
  const isMarketplaceEnabled = useIsContestMarketplaceEnabled();
  const hasEntry = !!contest?.entries.user;

  if (!isMarketplaceEnabled || !hasEntry) {
    return null;
  }

  return (
    <GamecenterNonScheduledNavListItem
      href={Routes.gamecenterMarketplace(contestId)}
      activeForRoutes={[Routes.gamecenterMarketplaceOffers(contestId)]}
      data-test-id={dt.contest.gamecenter.common.navigation.nonScheduled.marketplace}
    >
      {t('gamecenter.layoutNonScheduled.nav.marketplace')}
    </GamecenterNonScheduledNavListItem>
  );
}

export default GamecenterMarketplaceNavItem;
